var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSettingsSliders = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9646 4.50127C12.8248 4.50127 13.5527 3.94392 13.8339 3.17861H16.6958C17.0349 3.17861 17.3327 2.87913 17.3327 2.5048C17.3327 2.13046 17.0349 1.8393 16.6958 1.8393H13.8339C13.561 1.06567 12.8248 0.5 11.9646 0.5C11.1044 0.5 10.36 1.06567 10.087 1.8393H1.32772C0.955511 1.8393 0.666016 2.13046 0.666016 2.5048C0.666016 2.87913 0.955511 3.17861 1.32772 3.17861H10.0953C10.3682 3.94392 11.1044 4.50127 11.9646 4.50127ZM1.29463 6.91368C0.955511 6.91368 0.666016 7.21315 0.666016 7.58749C0.666016 7.96183 0.955511 8.25299 1.29463 8.25299H4.25576C4.52871 9.03494 5.26486 9.59229 6.12507 9.59229C6.98529 9.59229 7.72143 9.03494 8.00266 8.25299H16.6627C17.0349 8.25299 17.3327 7.96183 17.3327 7.58749C17.3327 7.21315 17.0349 6.91368 16.6627 6.91368H7.99439C7.72143 6.14837 6.98529 5.59102 6.12507 5.59102C5.26486 5.59102 4.52871 6.14837 4.25576 6.91368H1.29463ZM11.9646 14.6667C12.8248 14.6667 13.561 14.1093 13.8339 13.3357H16.6958C17.0349 13.3357 17.3327 13.0445 17.3327 12.6702C17.3327 12.2959 17.0349 11.9964 16.6958 11.9964H13.8339C13.561 11.2227 12.8248 10.6737 11.9646 10.6737C11.1044 10.6737 10.3682 11.2227 10.0953 11.9964H1.32772C0.955511 11.9964 0.666016 12.2959 0.666016 12.6702C0.666016 13.0445 0.955511 13.3357 1.32772 13.3357H10.087C10.3682 14.1093 11.1044 14.6667 11.9646 14.6667Z",
    fill: "#FCFCFC",
    stroke: "#FCFCFC",
    strokeWidth: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSettingsSliders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-settings-sliders.442e5b45bba72507daf9171cd9d5afbe.svg";